import { Action, createReducer, on } from '@ngrx/store';
import { UserLoginModel } from '../../shared/models/business-transaction/user-login.model';
import { TransactionApiActions } from './actions';
export interface TransactionState {
    users: UserLoginModel[];
    error: string;
}

export const initialState: TransactionState = {
    users: [],
    error: ''
};

export const transactionFeatureKey = 'transaction';

const transactionReducer = createReducer<TransactionState>(
    initialState,
    on(TransactionApiActions.loadUsersSuccess, (state, action): TransactionState => ({
        ...state,
        users: action.users,
        error: ''
    })),
    on(TransactionApiActions.loadUsersFailure, (state, action): TransactionState => ({
        ...state,
        users: [],
        error: action.error
    }))
);

export function reducer(state: TransactionState | undefined, action: Action) {
    return transactionReducer(state, action);
}
